import { computed, onBeforeUnmount, onMounted, ref } from 'vue';

export function useNow({ intervalMs = 1000 } = {}) {
  const now = ref(new Date());
  let timer = null;

  onMounted(() => {
    timer = window.setInterval(() => {
      now.value = new Date();
    }, intervalMs);
  });

  onBeforeUnmount(() => {
    if (timer) window.clearInterval(timer);
    timer = null;
  });

  return {
    now,
    nowMs: computed(() => now.value.getTime()),
  };
}

